import { ConfigurableText, NavigationPage } from '@/app/components'
import { ButtonContainer } from '@/app/pages/ava/BrandedPage'
import { Button, Icon } from '@/components'
import { getPermissionsEditUrl } from '../../verify-permissions/utils'
import systemConnectionFailureImgSrc from '@/app/img/system-connection-failure.webp'
import { useParams } from 'react-router-dom'
import { useNavigation } from '@/app/hooks'

export default function TeslaEnergySystemNoSystemInformation() {
  const { authenticationId } = useParams<{
    authenticationId: string
  }>()
  const navigation = useNavigation()
  const backUrl = `${window.location.origin}/tesla-fleet-auth-redirect/energy-system/${authenticationId}${window.location.search}`
  const editUrl = getPermissionsEditUrl(backUrl)

  return (
    <NavigationPage
      id="tesla-energy-system-no-system-information"
      navigationOptions={['back', 'close']}
      // go back to device selection
      backOverride={() => navigation.go(-2)}
      onCloseClick={() => navigation.goHome()}
    >
      <NavigationPage.SingleCardContent>
        <div className="flex flex-row items-start justify-start gap-3">
          <div className="w-5 h-5 mt-1">
            <Icon name="AlertCircleFilled" className="text-red-500 " />
          </div>
          <div className="flex flex-col gap-3">
            <ConfigurableText variant="h2">
              Uh oh, we have not detected any batteries.
            </ConfigurableText>
            <ConfigurableText variant="body4">
              You need to select{' '}
              <span className="font-bold">Energy Product Information</span> and{' '}
              <span className="font-bold">Energy Product Settings</span> from
              the Tesla permissions page.
            </ConfigurableText>
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <img
            src={systemConnectionFailureImgSrc}
            alt="System Connection Failure"
            className="w-full max-h-[300px] object-contain mt-8"
          />
        </div>
        <ButtonContainer>
          <Button
            id="update-permissions-button-no-vehicle-information"
            variant="primary"
            onClick={() => {
              window.location.href = editUrl
            }}
          >
            Update Permissions
          </Button>
        </ButtonContainer>
      </NavigationPage.SingleCardContent>
    </NavigationPage>
  )
}
